module.exports = __webpack_public_path__ + "img/DEFAULT_W.12fefab2.svg";